import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import authService from '../../services/authService';
import { useNavigate } from 'react-router-dom';

interface UpdatePasswordModalProps {
  open: boolean;
  onClose: () => void;
  userId: number;

}

const UpdatePasswordModal: React.FC<UpdatePasswordModalProps> = ({ open, onClose, userId }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);
    setError('');
    try {
     const retorno =  await authService.updatePassword(userId,{ password });
     
       navigate('/'); //colocar mensagem de retorno @Lucca

      onClose();
    } catch (err) {
      setError('Erro ao atualizar senha. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
          width: 400,
        }}
      >
        <Typography variant="h6" mb={2}>Atualizar Senha</Typography>

        <TextField
          label="Nova Senha"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Confirmar Senha"
          type="password"
          fullWidth
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          margin="normal"
        />

        {error && <Typography color="error" mt={1}>{error}</Typography>}

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button onClick={onClose} color="secondary" disabled={loading}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary" disabled={loading}>
            Atualizar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdatePasswordModal;
